module.exports = __webpack_public_path__ + "static/media/adaptive-ideation-systems.d4d4af88.png";